/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-redundant-type-constituents */
import { createStore } from './store/createStore';
import { middleware, rootReducers } from './store/storeRegistry';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

// create store
const storeGenerate = createStore(rootReducers, middleware);
export const store = storeGenerate.store;

// type definitions
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

// dispatch & selector:
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
